import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'serial-import-dialog',
  templateUrl: 'serial-import-dialog.html',
  styleUrls: ['./serial-import-dialog.css']
})
export class SerialImportDialog {
  Hvr: any = {};
  errorMessage: string = '';
  searchOpts:SNoSearchParams = new SNoSearchParams('file', '', '' ,'' , '', [], []);
  constructor(
    public dialogRef: MatDialogRef<SerialImportDialog>,
    @Inject(MAT_DIALOG_DATA) public serialNos: Array<string>) {
  }

  optionSelected(){
    this.searchOpts.extractedSerialNumbers.length = 0;
    this.searchOpts.serialNos.length = 0;
  }

  onFileChange(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});

      /* grab first sheet */
      var _tmpSerials:Array<string> = [];
      this.searchOpts.extractedSerialNumbers.length = 0;
      this.searchOpts.serialNos.length = 0;
      for(var i = 0; i < wb.SheetNames.length; i++){
        const wsname: string = wb.SheetNames[i];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];  
        
        var _jsonArr:Array<any> = XLSX.utils.sheet_to_json(ws, {header: 1});

        for(var j = 0;j < _jsonArr.length; j++){
          if(_jsonArr[j].length > 0){
            for(var k = 0;k < _jsonArr[j].length;k++){
              if(_jsonArr[j][k] && _jsonArr[j][k].trim().toLowerCase().indexOf("1vy") == 0){
                _tmpSerials.push(_jsonArr[j][k].trim().toUpperCase());
              }
            }
          }
        }
      }

      this.searchOpts.extractedSerialNumbers = _tmpSerials.filter((_token:string) => { return _token.trim() != ""; });
      this.searchOpts.serialNos.push(..._tmpSerials);
      
      /* save data */
      //this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
    };
    reader.readAsBinaryString(target.files[0]);
  }


  removeSNo(_serialNo:string){
    while(this.searchOpts.serialNos.indexOf(_serialNo) >= 0){
      this.searchOpts.serialNos.splice(this.searchOpts.serialNos.indexOf(_serialNo), 1);
    }
  }

  getSerialCountMessage():string{
    if(this.searchOpts.extractedSerialNumbers.length == 0){
      return "No serial numbers extracted.";
    }
    else if(this.searchOpts.extractedSerialNumbers.length == this.searchOpts.serialNos.length){
      return "Showing " + this.searchOpts.extractedSerialNumbers.length + " serial numbers extracted."
    }
    else{
      return "Selected " + this.searchOpts.serialNos.length + " of " + this.searchOpts.extractedSerialNumbers.length + " extracted.";
    }
  }
  extractSerialsPasted(){
    var _tokens:Array<string> = this.searchOpts.pastedSerialNosStr.split(/,|-|\t|\r|\n| /);

    this.searchOpts.extractedSerialNumbers = _tokens.filter((_token:string) => { return _token.trim() != ""; });

    this.searchOpts.serialNos.splice(0,this.searchOpts.serialNos.length,...this.searchOpts.extractedSerialNumbers)
    //this.serialNos = this.extractedSerialNumbers.slice(0);
  }


  extractSerialsFromTo(){
    this.searchOpts.serialNos.length = 0;
    this.searchOpts.serialExtractMessage = "";
    if(this.isRangeSerialNumbersValid() == true){
      var _rngSerials:Array<string> = this.getRangeSerialNos();
      if(_rngSerials != null){
        this.searchOpts.extractedSerialNumbers = _rngSerials.filter((_token:string) => { return _token.trim() != ""; });
        this.searchOpts.serialNos.push(..._rngSerials);
      }
    }
  }
  getRangeSerialNos():Array<string>{
    //to retain exisitng format in case leading zeros, add 1
    var _fromSerialStart:string = this.searchOpts.fromSerialNo.substring(0,4);
    var _toSerialStart:string = this.searchOpts.fromSerialNo.substring(0,4);
    var _fromSerialNo:number = parseInt(("1" + this.searchOpts.fromSerialNo.toLowerCase().replace(_fromSerialStart.toLowerCase(),'')),10);
    var _toSerialNo:number = parseInt(("1" + this.searchOpts.toSerialNo.toLowerCase().replace(_toSerialStart.toLowerCase(),'')),10);
    console.log(_fromSerialStart,_toSerialStart,_fromSerialNo,_toSerialNo)
    if(Number.isNaN(_fromSerialNo) || Number.isNaN(_toSerialNo)){
      this.searchOpts.serialExtractMessage = "Serial No is NOT VALID";
      return null;
    }
    if(_fromSerialNo > _toSerialNo){
      this.searchOpts.serialExtractMessage = "From Serial Cannot be more than To Serial.";
      return null;
    }
    if(_toSerialNo == _fromSerialNo){
      this.searchOpts.serialExtractMessage = "From Serial Cannot be equal to To Serial.";
      return null;
    }
    if(_toSerialNo - _fromSerialNo > 5000){
      this.searchOpts.serialExtractMessage = "You cannot view more than 5000 serial numbers at a glance.";
      return null;
    }

    var _retVal:Array<string> = [];
    for(var i = _fromSerialNo;i <= _toSerialNo; i++){
      //remove the leading one added earlier
      _retVal.push('1' + _fromSerialStart.toUpperCase() + (i + '').substring(1));
    }
    return _retVal;
  }
  isRangeSerialNumbersValid():boolean{
    if(this.searchOpts.fromSerialNo.trim() == ""  || this.searchOpts.toSerialNo.trim() == ""){
      this.searchOpts.serialExtractMessage = "Serial Nos CANNOT be empty";
      return false;
    }
    if(this.searchOpts.fromSerialNo.toLowerCase().indexOf("1vy") != 0  || 
       this.searchOpts.toSerialNo.toLowerCase().indexOf("1vy") != 0){
      this.searchOpts.serialExtractMessage = "Serial No SHOULD start with 1VY";
      return false;
    }
    return true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirmClick() {
    // this.errorMessage = '';
    // if (this.data.plannedDate && this.data.actualDate) {
    //   if (this.data.actualDate > this.data.plannedDate) {
    //     if (this.data.comments == null || this.data.comments == '') {
    //       this.errorMessage = '* Please Enter Reason for Delay';
    //       return;
    //     }
    //   }
    // }
    this.serialNos.push(...this.searchOpts.extractedSerialNumbers);
    this.dialogRef.close(true);
  }
}

export class SNoSearchParams{
    constructor(public serialOptSelection:string,  public pastedSerialNosStr:string,
        public fromSerialNo:string, public toSerialNo:string, public serialExtractMessage:string,
        public extractedSerialNumbers:Array<string>, public serialNos:Array<string>){}
}